const state = {
  meeting_time: ''
}

const mutations = {
  MEETING_TIME: (state, meeting_time) => {
    state.meeting_time = meeting_time
  }
}

// const actions = {
//   meetingTime({ commit }, meeting_time) {
//         commit('MEETING_TIME', meeting_time)
//   },
// }
const actions = {
  meetingCount({ commit }, data) {
    commit('MEETING_TIME', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
